import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';
import {
  TimingPair,
  timingPairStringify,
} from '@faire/web--source/common/timings/TimingMarker';

export const eventKey =
  'signin-hcaptcha_api_latency_timing_pair-action_unknown';

/**
 * We call the hCaptcha Client API before login and get a response token which is sent as a header to our login endpoint. This is to track how much time that call takes. Channel link:
https://faire-wholesale.slack.com/archives/C03110MDUH1
 */
export function trackSigninHcaptchaApiLatencyTimingPair(
  timingParameterToken: TimingPair
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: true,
    parameters: {
      timingParameterToken: timingPairStringify(timingParameterToken) ?? '',
    },
  });
}
